import { InjectionToken } from '@angular/core';
import { LineItemsColumn } from '../../../enums/line-items-column.enum';

export const LINE_ITEMS_DYNAMIC_CURRENCY_COLUMNS = new InjectionToken<LineItemsColumn[]>('LINE_ITEMS_DYNAMIC_CURRENCY_COLUMNS');
